export default "__VITE_ASSET__DaX5_tMM__"